module.exports = __webpack_public_path__ + "img/68.b6219b3e.jpg";